import { NavItem } from './general.known.routes';

export enum HumanTalentTrainingKnownItemId {
  HUMAN_TALENT_TRAINING,
  UPDATE_DATA,
  HUMAN_TALENT_TRAINING_LIST,
  DROP_OUT,
  DROP_OUT_VALIDATE_CODE,
}

const simpleTransformer = (input: NavItem): NavItem & { type: 'human-talent-training' } => {
  return {
    ...input,
    type: 'human-talent-training',
  };
};

export const HumanTalentTrainingKnownRoutes = (k: HumanTalentTrainingKnownItemId): NavItem => {
  return JSON.parse(JSON.stringify(options[k]));
};

const options: {
  [k in HumanTalentTrainingKnownItemId]: NavItem & { type: 'human-talent-training' };
} = {
  [HumanTalentTrainingKnownItemId.HUMAN_TALENT_TRAINING]: simpleTransformer({
    id: HumanTalentTrainingKnownItemId.HUMAN_TALENT_TRAINING,
    route: '/home/human-talent-training',
    iconName: 'academic-cap',
    displayName: 'Formación al Talento Humano',
  }),
  [HumanTalentTrainingKnownItemId.UPDATE_DATA]: simpleTransformer({
    id: HumanTalentTrainingKnownItemId.UPDATE_DATA,
    route: '/home/human-talent-training/update-data',
    iconName: 'account-box-pencil',
    displayName: 'Actualizar datos',
    parentModule: 'human-talent',
  }),
  [HumanTalentTrainingKnownItemId.HUMAN_TALENT_TRAINING_LIST]: simpleTransformer({
    id: HumanTalentTrainingKnownItemId.HUMAN_TALENT_TRAINING_LIST,
    route: '/home/human-talent-training/list',
    iconName: 'academic-cap',
    displayName: 'FORMACIÓN AL TALENTO HUMANO',
    parentModule: 'human-talent',
  }),
  [HumanTalentTrainingKnownItemId.DROP_OUT]: simpleTransformer({
    id: HumanTalentTrainingKnownItemId.DROP_OUT,
    route: '/home/human-talent-training/update-data/drop-out',
    iconName: 'incident-close',
    displayName: 'DAR DE BAJA EN EL SISTEMA',
    parentModule: 'human-talent',
  }),
  [HumanTalentTrainingKnownItemId.DROP_OUT_VALIDATE_CODE]: simpleTransformer({
    id: HumanTalentTrainingKnownItemId.DROP_OUT_VALIDATE_CODE,
    route: '/home/human-talent-training/update-data/drop-out/validate-code',
    iconName: 'incident-close',
    displayName: 'DAR DE BAJA EN EL SISTEMA',
    parentModule: 'human-talent',
  }),
};
